import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportDeviceMounts(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORT_DEVICE_MOUNTS,
		ModulesConfigMap[ModulesMap.REPORT_DEVICE_MOUNTS].GET_REPORT_DEVICE_MOUNTS,
		options
	)
}
function _getReportDeviceMount(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORT_DEVICE_MOUNTS,
		ModulesConfigMap[ModulesMap.REPORT_DEVICE_MOUNTS].GET_REPORT_DEVICE_MOUNT,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.REPORT_DEVICE_MOUNTS].GET_REPORT_DEVICE_MOUNTS]: _getReportDeviceMounts,
	[ModulesConfigMap[ModulesMap.REPORT_DEVICE_MOUNTS].GET_REPORT_DEVICE_MOUNT]: _getReportDeviceMount,

}